<template>
  <div :class="classObj" class="app-wrapper">
    <div class="main-container">
      <app-main/>
    </div>
  </div>
</template>

<script>
import AppMain from './components/AppMain'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'Layout',
  components: {
    AppMain,
  },
  mixins: [ResizeMixin],
  computed: {
    device() {
      return this.$store.state.device
    },
    classObj() {
      return {
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
  @import "@/styles/mixin.scss";

  .app-wrapper {
    height: 100%;

    .main-container {
        height: 100%;
    }
  }
</style>
